import { twMerge } from '@shared/themes';
import { NumberFormats as nf, useCurrencyFormatter } from '@shared/utils';
import { useTranslations } from 'next-intl';
import React from 'react';
import type { PromotionAmount } from '../types';

type WinningProps = {
  winnings?: PromotionAmount;
  label: string;
  className?: string;
  namespace: string;
};

const Winning: React.FC<WinningProps> = ({ winnings, label, className, namespace }) => {
  const currencyFormatter = useCurrencyFormatter();
  const t = useTranslations(namespace);
  if (!winnings) return null;

  const title = t(`${label}.title`);
  const message = t(`${label}.message`, { amount: winnings.amount });

  return (
    <div className={twMerge('bg-container rounded-lg p-5', className)} data-testid="winning-panel">
      <div className="flex justify-between items-center mb-2">
        <p className="paragraph-strong" data-testid="winning-title">
          {title}
        </p>
        <p className="paragraph-strong text-success-foreground">{currencyFormatter(winnings.fixed_amount).format(nf.WITH_DECIMALS).get()}</p>
      </div>
      <p className="paragraph-s text-foreground" data-testid="winning-message">
        {message}
      </p>
    </div>
  );
};

export { Winning, type WinningProps };
